import { Paper, Typography } from "@mui/material"
import ProcurementContainer from "../../procurement/containers/ProcurementContainer"
import ApprovedPaymentRequisitionsList from "../lists/approvedPaymentRequisitionsList"
import React from "react";

const ApprovedPaymentRequisitionsPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Prioritized Payment Requests
      </Typography>
      <Paper sx={{my: 5}}>
        <ApprovedPaymentRequisitionsList/>
      </Paper>
    </ProcurementContainer>
   
  )
}

export default ApprovedPaymentRequisitionsPage
